import { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";

export function PageTransition() {
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (prevPath.current !== location.pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      prevPath.current = location.pathname;
    }
  }, [location.pathname]);

  return (
    <div className="eh-page-enter min-w-0 max-w-full">
      <Outlet />
    </div>
  );
}
